var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", [
        _c(
          "div",
          { staticClass: "mobile-page paddingBox", style: _vm.boxStyle },
          [
            _c(
              "div",
              { staticClass: "home_product" },
              [
                _vm.itemStyle == 0
                  ? [
                      _vm.list.length > 0
                        ? _c(
                            "div",
                            { staticClass: "list-wrapper itemA" },
                            _vm._l(_vm.list, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "item",
                                  style: {
                                    marginBottom: _vm.contentConfig + "px",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "img-box" }, [
                                    _vm.tempLabel(item)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "corner-label",
                                            class:
                                              "temp-" + item.storageTempControl,
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.tempLabel(item)) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    item.image
                                      ? _c("img", {
                                          style: _vm.contentStyle,
                                          attrs: { src: item.image, alt: "" },
                                        })
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "empty-box",
                                            style: _vm.contentStyle,
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "iconfont icontupian",
                                            }),
                                          ]
                                        ),
                                  ]),
                                  _c("div", { staticClass: "info" }, [
                                    _c("div", { staticClass: "hd" }, [
                                      _c("div", { staticClass: "text" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [
                                            _vm.titleShow
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(item.storeName)
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cart-btn",
                                        style: _vm.cartBtnStyle,
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-plus",
                                        }),
                                        _vm.cartCount(item) > 0
                                          ? _c(
                                              "span",
                                              { staticClass: "cart-badge" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.cartCount(item))
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "price",
                                        style: _vm.priceColor,
                                      },
                                      [
                                        _vm.priceShow
                                          ? _c("div", { staticClass: "num" }, [
                                              _vm._v(" ￥"),
                                              _c("span", [
                                                _vm._v(_vm._s(item.price)),
                                              ]),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm.soldShow
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "sold",
                                            style: _vm.soldColor,
                                          },
                                          [
                                            _vm._v(
                                              " 已售 " +
                                                _vm._s(
                                                  Math.floor(item.sales) +
                                                    Math.floor(item.ficti)
                                                ) +
                                                " " +
                                                _vm._s(item.unitName) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              )
                            }),
                            0
                          )
                        : _c("div", { staticClass: "list-wrapper itemA" }, [
                            _c(
                              "div",
                              {
                                staticClass: "item",
                                style: {
                                  marginBottom: _vm.contentConfig + "px",
                                },
                              },
                              [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    { staticClass: "corner-label temp-2" },
                                    [_vm._v("冷藏")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd" }, [
                                    _c("div", { staticClass: "text" }, [
                                      _c(
                                        "div",
                                        { staticClass: "title line2" },
                                        [
                                          _vm.titleShow
                                            ? _c(
                                                "span",
                                                { style: _vm.titleColor },
                                                [_vm._v("商品名称")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cart-btn",
                                      style: _vm.cartBtnStyle,
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-plus" }),
                                      _vm.cartCount(_vm.item) > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "cart-badge" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.cartCount(_vm.item))
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("199")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "item",
                                style: {
                                  marginBottom: _vm.contentConfig + "px",
                                },
                              },
                              [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    { staticClass: "corner-label temp-2" },
                                    [_vm._v("冷藏")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd" }, [
                                    _c("div", { staticClass: "text" }, [
                                      _c(
                                        "div",
                                        { staticClass: "title line2" },
                                        [
                                          _vm.titleShow
                                            ? _c(
                                                "span",
                                                { style: _vm.titleColor },
                                                [_vm._v("商品名称")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cart-btn",
                                      style: _vm.cartBtnStyle,
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-plus" }),
                                      _vm.cartCount(_vm.item) > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "cart-badge" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.cartCount(_vm.item))
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("199")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                          ]),
                    ]
                  : _vm._e(),
                _vm.itemStyle == 1
                  ? [
                      _vm.list.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "list-wrapper waterfall waterfall-2",
                              style: { columnGap: _vm.contentConfig + "px" },
                            },
                            _vm._l(_vm.list, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "item",
                                  style: {
                                    marginBottom: _vm.contentConfig + "px",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "img-box" }, [
                                    _vm.tempLabel(item)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "corner-label",
                                            class:
                                              "temp-" + item.storageTempControl,
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.tempLabel(item)) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    item.image
                                      ? _c("img", {
                                          style: _vm.contentStyle,
                                          attrs: { src: item.image, alt: "" },
                                        })
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "empty-box",
                                            style: _vm.contentStyle,
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "iconfont icontupian",
                                            }),
                                          ]
                                        ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "info acea-row row-column row-between info-box",
                                    },
                                    [
                                      _c("div", { staticClass: "top-info" }, [
                                        _vm.titleShow
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "hd line2 title",
                                                style: _vm.titleColor,
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(item.storeName)
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.pickupInfo(item).text
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "pickup-text",
                                                class: {
                                                  warn: _vm.pickupInfo(item)
                                                    .warn,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.pickupInfo(item).text
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cart-btn",
                                            style: _vm.cartBtnStyle,
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-plus",
                                            }),
                                            _vm.cartCount(item) > 0
                                              ? _c(
                                                  "span",
                                                  { staticClass: "cart-badge" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.cartCount(item)
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "price",
                                            style: _vm.priceColor,
                                          },
                                          [
                                            _vm.priceShow
                                              ? _c(
                                                  "div",
                                                  { staticClass: "num" },
                                                  [
                                                    _vm._v(" ¥"),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(item.price)
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.priceShow &&
                                            Number(item.otPrice) > 0
                                              ? _c(
                                                  "div",
                                                  { staticClass: "old-price" },
                                                  [
                                                    _vm._v(
                                                      "¥" + _vm._s(item.otPrice)
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm.soldShow
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "sold",
                                                style: _vm.soldColor,
                                              },
                                              [
                                                _vm._v(
                                                  " 已售 " +
                                                    _vm._s(
                                                      Math.floor(item.sales) +
                                                        Math.floor(
                                                          item.ficti
                                                        ) || 0
                                                    ) +
                                                    " " +
                                                    _vm._s(item.unitName) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "list-wrapper waterfall waterfall-2",
                              style: { columnGap: _vm.contentConfig + "px" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item",
                                  style: {
                                    marginBottom: _vm.contentConfig + "px",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "img-box" }, [
                                    _c(
                                      "div",
                                      { staticClass: "corner-label temp-2" },
                                      [_vm._v("冷藏")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "empty-box",
                                        style: _vm.contentStyle,
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "iconfont icontupian",
                                        }),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "info acea-row row-column row-between info-box",
                                    },
                                    [
                                      _c("div", { staticClass: "top-info" }, [
                                        _vm.titleShow
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "hd line2 title",
                                                style: _vm.titleColor,
                                              },
                                              [_vm._v("商品名称")]
                                            )
                                          : _vm._e(),
                                        _vm.pickupText
                                          ? _c(
                                              "div",
                                              { staticClass: "pickup-text" },
                                              [_vm._v(_vm._s(_vm.pickupText))]
                                            )
                                          : _vm._e(),
                                      ]),
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cart-btn",
                                            style: _vm.cartBtnStyle,
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-plus",
                                            }),
                                            _vm.cartCount(_vm.item) > 0
                                              ? _c(
                                                  "span",
                                                  { staticClass: "cart-badge" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.cartCount(_vm.item)
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "price",
                                            style: _vm.priceColor,
                                          },
                                          [
                                            _vm.priceShow
                                              ? _c(
                                                  "div",
                                                  { staticClass: "num" },
                                                  [
                                                    _vm._v("¥"),
                                                    _c("span", [
                                                      _vm._v("66.66"),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.priceShow
                                              ? _c(
                                                  "div",
                                                  { staticClass: "old-price" },
                                                  [_vm._v("¥88.88")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm.soldShow
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "sold",
                                                style: _vm.soldColor,
                                              },
                                              [_vm._v("已售 999 件")]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "item",
                                  style: {
                                    marginBottom: _vm.contentConfig + "px",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "img-box" }, [
                                    _c(
                                      "div",
                                      { staticClass: "corner-label temp-2" },
                                      [_vm._v("冷藏")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "empty-box",
                                        style: _vm.contentStyle,
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "iconfont icontupian",
                                        }),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "info acea-row row-column row-between info-box",
                                    },
                                    [
                                      _c("div", { staticClass: "top-info" }, [
                                        _vm.titleShow
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "hd line2 title",
                                                style: _vm.titleColor,
                                              },
                                              [_vm._v("商品名称")]
                                            )
                                          : _vm._e(),
                                        _vm.pickupText
                                          ? _c(
                                              "div",
                                              { staticClass: "pickup-text" },
                                              [_vm._v(_vm._s(_vm.pickupText))]
                                            )
                                          : _vm._e(),
                                      ]),
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cart-btn",
                                            style: _vm.cartBtnStyle,
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-plus",
                                            }),
                                            _vm.cartCount(_vm.item) > 0
                                              ? _c(
                                                  "span",
                                                  { staticClass: "cart-badge" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.cartCount(_vm.item)
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "price",
                                            style: _vm.priceColor,
                                          },
                                          [
                                            _vm.priceShow
                                              ? _c(
                                                  "div",
                                                  { staticClass: "num" },
                                                  [
                                                    _vm._v("¥"),
                                                    _c("span", [
                                                      _vm._v("66.66"),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.priceShow
                                              ? _c(
                                                  "div",
                                                  { staticClass: "old-price" },
                                                  [_vm._v("¥88.88")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm.soldShow
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "sold",
                                                style: _vm.soldColor,
                                              },
                                              [_vm._v("已售 999 件")]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                    ]
                  : _vm._e(),
                _vm.itemStyle == 2
                  ? [
                      _vm.list.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "list-wrapper itemB",
                              style: { gridGap: _vm.contentConfig + "px" },
                            },
                            _vm._l(_vm.list, function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "item auto" },
                                [
                                  _c("div", { staticClass: "img-box" }, [
                                    _vm.tempLabel(item)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "corner-label",
                                            class:
                                              "temp-" + item.storageTempControl,
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.tempLabel(item)) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    item.image
                                      ? _c("img", {
                                          style: _vm.contentStyle,
                                          attrs: { src: item.image, alt: "" },
                                        })
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "empty-box",
                                            style: _vm.contentStyle,
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "iconfont icontupian",
                                            }),
                                          ]
                                        ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "info acea-row row-column row-between info-box",
                                    },
                                    [
                                      _vm.titleShow
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "hd line2 title",
                                              style: _vm.titleColor,
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(item.storeName)),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cart-btn",
                                            style: _vm.cartBtnStyle,
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-plus",
                                            }),
                                            _vm.cartCount(item) > 0
                                              ? _c(
                                                  "span",
                                                  { staticClass: "cart-badge" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.cartCount(item)
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "price",
                                            style: _vm.priceColor,
                                          },
                                          [
                                            _vm.priceShow
                                              ? _c(
                                                  "div",
                                                  { staticClass: "num" },
                                                  [
                                                    _vm._v(" ¥"),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(item.price)
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm.soldShow
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "sold",
                                                style: _vm.soldColor,
                                              },
                                              [
                                                _vm._v(
                                                  " 已售 " +
                                                    _vm._s(
                                                      Math.floor(item.sales) +
                                                        Math.floor(
                                                          item.ficti
                                                        ) || 0
                                                    ) +
                                                    " " +
                                                    _vm._s(item.unitName) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "list-wrapper itemB",
                              style: { gridGap: _vm.contentConfig + "px" },
                            },
                            [
                              _c("div", { staticClass: "item auto" }, [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    { staticClass: "corner-label temp-2" },
                                    [_vm._v("冷藏")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd acea-row" }, [
                                    _vm.titleShow
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [_vm._v("商品名称")]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cart-btn",
                                      style: _vm.cartBtnStyle,
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-plus" }),
                                      _vm.cartCount(_vm.item) > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "cart-badge" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.cartCount(_vm.item))
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("66.66")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                              _c("div", { staticClass: "item auto" }, [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    { staticClass: "corner-label temp-2" },
                                    [_vm._v("冷藏")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd acea-row" }, [
                                    _vm.titleShow
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [_vm._v("商品名称")]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cart-btn",
                                      style: _vm.cartBtnStyle,
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-plus" }),
                                      _vm.cartCount(_vm.item) > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "cart-badge" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.cartCount(_vm.item))
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("66.66")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                              _c("div", { staticClass: "item auto" }, [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    { staticClass: "corner-label temp-2" },
                                    [_vm._v("冷藏")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd acea-row" }, [
                                    _vm.titleShow
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [_vm._v("商品名称")]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cart-btn",
                                      style: _vm.cartBtnStyle,
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-plus" }),
                                      _vm.cartCount(_vm.item) > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "cart-badge" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.cartCount(_vm.item))
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("66.66")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                            ]
                          ),
                    ]
                  : _vm._e(),
                _vm.itemStyle == 3
                  ? [
                      _vm.list.length > 0
                        ? _c(
                            "div",
                            { staticClass: "listBig" },
                            _vm._l(_vm.list, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "itemBig",
                                  style: {
                                    marginBottom: _vm.contentConfig + "px",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "img-box" }, [
                                    _vm.tempLabel(item)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "corner-label",
                                            class:
                                              "temp-" + item.storageTempControl,
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.tempLabel(item)) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    item.image
                                      ? _c("img", {
                                          style: _vm.contentStyle,
                                          attrs: { src: item.image, alt: "" },
                                        })
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "empty-box",
                                            style: _vm.contentStyle,
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "iconfont icontupian",
                                            }),
                                          ]
                                        ),
                                  ]),
                                  _c("div", { staticClass: "info" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "hd line2 title",
                                        style: _vm.titleColor,
                                      },
                                      [
                                        _vm.titleShow
                                          ? _c("span", [
                                              _vm._v(_vm._s(item.storeName)),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cart-btn",
                                        style: _vm.cartBtnStyle,
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-plus",
                                        }),
                                        _vm.cartCount(item) > 0
                                          ? _c(
                                              "span",
                                              { staticClass: "cart-badge" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.cartCount(item))
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "price",
                                        style: _vm.priceColor,
                                      },
                                      [
                                        _vm.priceShow
                                          ? _c("div", { staticClass: "num" }, [
                                              _vm._v(" ¥"),
                                              _c("span", [
                                                _vm._v(_vm._s(item.price)),
                                              ]),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm.soldShow
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "sold",
                                            style: _vm.soldColor,
                                          },
                                          [
                                            _vm._v(
                                              " 已售 " +
                                                _vm._s(
                                                  Math.floor(item.sales) +
                                                    Math.floor(item.ficti) || 0
                                                ) +
                                                " " +
                                                _vm._s(item.unitName) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              )
                            }),
                            0
                          )
                        : _c("div", { staticClass: "listBig" }, [
                            _c(
                              "div",
                              {
                                staticClass: "itemBig",
                                style: {
                                  marginBottom: _vm.contentConfig + "px",
                                },
                              },
                              [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    { staticClass: "corner-label temp-2" },
                                    [_vm._v("冷藏")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd acea-row" }, [
                                    _vm.titleShow
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [_vm._v("商品名称")]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cart-btn",
                                      style: _vm.cartBtnStyle,
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-plus" }),
                                      _vm.cartCount(_vm.item) > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "cart-badge" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.cartCount(_vm.item))
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("66.66")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "itemBig",
                                style: {
                                  marginBottom: _vm.contentConfig + "px",
                                },
                              },
                              [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    { staticClass: "corner-label temp-2" },
                                    [_vm._v("冷藏")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd acea-row" }, [
                                    _vm.titleShow
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [_vm._v("商品名称")]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cart-btn",
                                      style: _vm.cartBtnStyle,
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-plus" }),
                                      _vm.cartCount(_vm.item) > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "cart-badge" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.cartCount(_vm.item))
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("66.66")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                          ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }